import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel } from 'common/models/utilitymodels/base.model';

export class AppModel extends BaseDataModel {}

export class AppMetaModel extends FormMetaModel {
    constructor() {
        super('App', '', false, '');
    }
    showMaintanance = false;
    initProperties() {
        return {
            showMaintanance: this.showMaintanance,
        };
    }
}
